import React, { useState } from 'react';
import { searchForDuplicateId } from '../utils/searchDatabase';

const DatabaseSearch = () => {
  const [searching, setSearching] = useState(false);
  const [results, setResults] = useState(null);

  const runSearch = async () => {
    setSearching(true);
    try {
      const searchResults = await searchForDuplicateId();
      setResults(searchResults);
    } catch (error) {
      console.error('Search failed:', error);
    } finally {
      setSearching(false);
    }
  };

  return (
    <div style={{ padding: '2rem', maxWidth: '800px', margin: '0 auto' }}>
      <h1>Database Search Tool</h1>
      <p>Searching for ID: <code>kpJQvSOGpEEIUsn2kYJI</code></p>
      
      <button 
        onClick={runSearch} 
        disabled={searching}
        style={{
          padding: '12px 24px',
          fontSize: '16px',
          backgroundColor: '#007bff',
          color: 'white',
          border: 'none',
          borderRadius: '8px',
          cursor: searching ? 'not-allowed' : 'pointer',
          marginBottom: '2rem'
        }}
      >
        {searching ? 'Searching...' : 'Search Database'}
      </button>

      {results && (
        <div style={{ 
          backgroundColor: '#f8f9fa', 
          padding: '1.5rem', 
          borderRadius: '8px',
          marginTop: '1rem'
        }}>
          <h2>Search Results</h2>
          <p><strong>Total occurrences found:</strong> {results.totalFound}</p>
          <p><strong>Has duplicates:</strong> {results.hasDuplicates ? '⚠️ YES' : '✅ NO'}</p>
          
          {results.results.length > 0 && (
            <div>
              <h3>Details:</h3>
              {results.results.map((result, index) => (
                <div key={index} style={{
                  backgroundColor: 'white',
                  padding: '1rem',
                  margin: '0.5rem 0',
                  borderRadius: '6px',
                  border: '1px solid #dee2e6'
                }}>
                  <p><strong>Collection:</strong> {result.collection}</p>
                  <p><strong>Type:</strong> {result.found}</p>
                  <p><strong>Document ID:</strong> {result.id}</p>
                  <details>
                    <summary>View Data</summary>
                    <pre style={{ 
                      backgroundColor: '#f1f3f4', 
                      padding: '0.5rem', 
                      borderRadius: '4px',
                      overflow: 'auto',
                      fontSize: '12px'
                    }}>
                      {JSON.stringify(result.data, null, 2)}
                    </pre>
                  </details>
                </div>
              ))}
            </div>
          )}
          
          <div style={{ marginTop: '1rem', padding: '1rem', backgroundColor: '#fff3cd', borderRadius: '6px' }}>
            <p><strong>Note:</strong> Check the browser console for detailed logs during the search process.</p>
          </div>
        </div>
      )}
    </div>
  );
};

export default DatabaseSearch; 